<template>
    <q-layout view="lhr lpr lfr">
        <q-header>
            <gfk-header :title="siteTitle" :subtitle="siteSubtitle"/>
        </q-header>
        <q-page-container>
            <q-page>
            <div class="row gutter-xs">
                <div class="col-lg-12" style="width: 100%;">
                    <q-card class="bg-white no-margin full-height">
                        <q-card-section class="q-card-title">Login to your account</q-card-section>
                        <q-card-section class="IDcontrols">
                            <q-field class="q-field-height" error-message="Please type a username" :error="v$.username.$error">
                                <q-input
                                        class="login-input"
                                         v-model="username"
                                         label="Username"
                                         :error="v$.username.$error"
                                         clearable
                                         :readonly="submit"
                                         @blur="onUserNameEntry"
                                         @keyup="onUserNameEntry"
                                         @keyup.enter="login"

                                />
                            </q-field>
                            <q-field class="q-field-height" :error-message="passwordErrorLabel" :error="v$.password.$error">
                                <q-input type="password"
                                        class="login-input"
                                         v-model="password"
                                         label="Password"
                                         :error="v$.password.$error"
                                         :readonly="submit"
                                         @blur="onPasswordEntry"
                                         @keyup="onPasswordEntry"
                                         @keyup.enter="login"

                                />
                            </q-field>
                                <div class="row justify-end">
                                    <div class="col-auto">
                                        <q-btn color="deep-orange" v-model="submit"  @click="login" >
                                            Login
                                        </q-btn>
                                    </div>
                                </div>
                        </q-card-section>
                    </q-card>
                </div>
            </div>
            </q-page>
        </q-page-container>
            <div class="q-pa-md q-gutter-sm">
                <q-dialog v-model="passwordChange">
                    <q-card>
                        <q-card-section class="gfk-bg-primary text-white dialog-header-footer">
                            <q-toolbar slot="header">
                                <q-toolbar-title style="font-size: 1.1em;">Password change required</q-toolbar-title>
                            </q-toolbar>
                        </q-card-section>
                        <q-card-section style="width: 25em;" class="scroll dialog-main-content">
                            <div class="layout-padding justify-center">
                                <q-field :error-message="passwordNewLabel" :error="v$.passwordNew.$error">
                                    <q-input 
                                        :type="newPwd ? 'password' : 'text'" 
                                        style="width: 100%;"  
                                        v-model="passwordNew" 
                                        stack-label label="New Password" 
                                        :readonly="submit"
                                        v-on:keyup="validateNewPassword"
                                        v-on:focus="npShow=true"
                                        v-on:blur="npShow=false"
                                    >
                                    <q-tooltip v-model="npShow" no-parent-event anchor="bottom middle">
                                        <q-card class="text-black" style="font-size: 0.8rem !important;" >
                                            <q-card-section>
                                                <q-list dense padding class="rounded-borders">
                                                    <q-item dense clickable v-ripple>
                                                        <q-item-section thumbnail top left>
                                                            <q-icon :name="npMinLen ? 'check_circle' : 'remove_circle_outline'" :color="npMinLen ? 'green': ''"/>
                                                        </q-item-section>
                                                        <q-item-section>
                                                            15-character minimum length
                                                        </q-item-section>
                                                    </q-item>
                                                    <q-item dense clickable v-ripple>
                                                        <q-item-section thumbnail top left>
                                                            <q-icon :name="npOneNumber ? 'check_circle' : 'remove_circle_outline'" :color="npOneNumber ? 'green': ''" />
                                                        </q-item-section>
                                                        <q-item-section>
                                                            Contains at least 1 number
                                                        </q-item-section>
                                                    </q-item>
                                                    <q-item dense clickable v-ripple>
                                                        <q-item-section thumbnail top left>
                                                            <q-icon :name="npOneLowerChar ? 'check_circle' : 'remove_circle_outline'" :color="npOneLowerChar ? 'green': ''"/>
                                                        </q-item-section>
                                                        <q-item-section>
                                                            Contains at least 1 lowercase letter
                                                        </q-item-section>
                                                    </q-item>
                                                    <q-item dense clickable v-ripple>
                                                        <q-item-section thumbnail top left>
                                                            <q-icon :name="npOneUpperChar ? 'check_circle' : 'remove_circle_outline'" :color="npOneUpperChar ? 'green': ''" />
                                                        </q-item-section>
                                                        <q-item-section>
                                                            Contains at least 1 uppercase letter
                                                        </q-item-section>
                                                    </q-item>
                                                    <q-item dense clickable v-ripple>
                                                        <q-item-section thumbnail top left>
                                                            <q-icon :name="npOneSpecialChar ? 'check_circle' : 'remove_circle_outline'" :color="npOneSpecialChar ? 'green': ''" />
                                                        </q-item-section>
                                                        <q-item-section>
                                                            Contains at least 1 special character from the following set, or a non-leading, non-trailing space character.
                                                            <code>^ $ * . [ ] { } ( ) ? - " ! @ # % & / \ , &gt; &lt; ' : ; | _ ~ ` + =</code>
                                                        </q-item-section>
                                                    </q-item>
                                                </q-list>
                                            </q-card-section>
                                        </q-card>
                                    </q-tooltip>
                                        <template v-slot:append>
                                            <q-icon
                                            :name="newPwd ? 'visibility_off' : 'visibility'"
                                            class="cursor-pointer"
                                            @click="newPwd = !newPwd"
                                            />
                                        </template>
                                    </q-input>
                                </q-field>
                                <q-field class="q-pt-md" :error-message="passwordNewConfirmLabel" :error="v$.passwordNewConfirm.$error">
                                    <q-input 
                                        :type="confirmPwd ? 'password' : 'text'" 
                                        style="width: 100%;" 
                                        v-model="passwordNewConfirm" 
                                        stack-label label="New Password(confirm)" 
                                        :readonly="submit"
                                        v-on:keyup="validateConfirmPassword"
                                        >
                                        <template v-slot:append>
                                            <q-icon
                                              :name="confirmPwd ? 'visibility_off' : 'visibility'"
                                              class="cursor-pointer"
                                              @click="confirmPwd = !confirmPwd"
                                            />
                                          </template>
                                    </q-input> 
                                </q-field>
                                <div class="q-pt-md q-gutter-sm">
                                <q-btn  color="deep-orange"
                                    v-model="submit"
                                    :error="passwordNew == '' || passwordNewConfirm == '' || passwordNew != passwordNewConfirm"
                                    @click="updatePassword">
                                    Update Password
                                </q-btn>
                            </div>
                            </div>
                        </q-card-section>
                        <q-card-section elevated class="gfk-bg-primary text-white dialog-header-footer">
                                <q-toolbar slot="footer">
                                </q-toolbar>
                        </q-card-section>
                    </q-card>
                </q-dialog>
            </div>
        <q-footer><gfk-footer/></q-footer>
    </q-layout>
</template>

<script>
	// import { validationMixin } from 'vuelidate';
    import { reactive } from 'vue'
    import { useVuelidate } from '@vuelidate/core'
	import { integer, required } from '@vuelidate/validators';

	import {
        QLayout, QHeader, QCard, QCardSection, QBtn, QField, QInput, QToolbar, QSpinner, QPageContainer, QFooter, QDialog, QPage, QToolbarTitle, QIcon, QTooltip, QList, QItem, QItemSection
    } from 'quasar';
	import gfkHeader from './gfk-header.vue';
	import gfkFooter from './gfk-footer.vue';
	import authenticateApi from '../api/auth';
	import siteData from '../mixins/site-data-mixin';
    import { ref } from 'vue'

	export default {
		mixins: [siteData],
        setup () {
            const state = reactive({
                username: '',
                password: '',
                passwordNewConfirm: '',
                passwordNew: ''
            })
            const rules = {
                username: { required },
                password: { required },
                passwordNewConfirm : {required},
                passwordNew : {required}
            }

            const v$ = useVuelidate(rules, state)

            return { state, v$ }
        },
		components: {
			gfkHeader,
			gfkFooter,
			QLayout,
			QCard,
			QBtn,
			QField,
			QInput,
            QToolbar,
            QSpinner,
            QPageContainer,
            QFooter,
            QCardSection,
            QHeader,
            QDialog,
            QPage,
            QToolbarTitle,
            QIcon,
            QTooltip,
            QList,
            QItem,
            QItemSection
		},
		data() {
			return {
				username: '',
				password: '',
				submit: false,
                userNameErrorLabel : 'Please type a username',
				passwordErrorLabel: 'Please type a password',
				loginFailed: false,
                passwordChange: false,
                passwordNewConfirm: '',
                passwordNew:'',
                passwordNewLabel: 'Please enter new password',
                passwordNewConfirmLabel: 'Please confirm new password',
                passwordChangeErrorLabel: 'New password must not be empty; the two passwords must match; Passwords must be at least 15 characters, containing letters (inc. uppercase), numbers, and special characters',
                npShow: ref(false),
                newPwd: ref(true),  
                confirmPwd: ref(true),
                npMinLen : ref(false),
                npOneNumber: ref(false),
                npOneLowerChar: ref(false),
                npOneUpperChar: ref(false),
                npOneSpecialChar: ref(false),
                passVal: ref(false),
                isValidPassword: ref(false)      
			};
		},
		methods: {
            validateConfirmPassword(event){
                this.v$.passwordNewConfirm.$reset();
                if( !this.passwordNew || !event.target.value || this.passwordNew!=event.target.value){
                    if(event.target.value){
                        this.passwordNewConfirmLabel='New password and confirmed password must be same';
                    }
                    this.v$.passwordNewConfirm.$touch();
                }
            },
            validateNewPassword(event){
                const val = event.target.value
                this.npMinLen = val.length >= 15;
                this.npOneNumber = /\d/.test(val);
                this.npOneUpperChar= /[A-Z]/.test(val);
                this.npOneLowerChar = /[a-z]/.test(val);
                this.npOneSpecialChar = /[\^$*.[\]{}()?\\\-!"@#%&\/,><':;|_~`+=]/.test(val);
                if(this.npMinLen && this.npOneNumber && this.npOneUpperChar && this.npOneLowerChar & this.npOneSpecialChar) {
                    this.isValidPassword=true;
                    this.v$.passwordNew.$reset();
                }else{
                    if(this.passwordNew){
                        this.passwordNewLabel='Password does not meet requirements';
                    }else{
                        this.passwordNewLabel='Please enter new password'
                    }
                    this.v$.passwordNew.$touch();
                }
            },
            onUserNameEntry(){
                if(!this.username){
                    this.v$.username.$touch();
                    return;
                }
                this.v$.username.$reset();
            },
			onPasswordEntry() {
                if(!this.password){
                    this.v$.password.$touch();
                    return;
                }
                this.v$.password.$reset();
			},
            updatePassword() {
                this.submit = true;
                if (!this.passwordNew || !this.passwordNewConfirm) {
                    if(!this.passwordNew){
                        this.v$.passwordNew.$touch();
                    }
                    if(!this.passwordNewConfirm){
                        this.v$.passwordNewConfirm.$touch();
                    }
                    this.submit=false;
                    return;
                }
                if(this.passwordNew==this.passwordNewConfirm && !this.isValidPassword){
                    this.passwordNewConfirmLabel="Please enter valid password";
                    this.v$.passwordNewConfirm.$touch();
                    this.submit=false;
                    return;
                }
                console.log('Username ------', this.username);
                console.log('password ------', this.password);
                console.log('new password ------', this.passwordNew)
                authenticateApi.updatePassword(this.username, this.password, this.passwordNew).then(
                    () => {
                        this.submit = false;
                        this.$router.replace({ name: 'caseidStart' });
                    },
                    (err) => {
                        console.log(err);
                        this.submit = false;
                        this.passwordNewConfirmLabel = 'Unable to process request.';
                        this.v$.passwordNewConfirm.$touch();
                        this.loginFailed = true;
                    }
                );
            },
			login() {
				if (!this.username && !this.password) {
					this.v$.$touch();
					return;
				}

                
				this.submit = true;
				authenticateApi.authenticate(this.username, this.password).then(
                    (followUp) => {
                        //followUp="NEW_PASSWORD_REQUIRED";
                        if (followUp === authenticateApi.NEW_PASSWORD_REQUIRED) {
                            this.passwordChange = true;
                            this.npShow=false;
                            this.submit = false;
                        } else {
                            this.submit = false;

                            this.$router.replace({ name: 'caseidStart' });
                        }
					},
					(err) => {
                        console.log(err);
						this.submit = false;
						this.passwordErrorLabel = 'Invalid user name or password';
                        this.v$.password.$touch();
						this.loginFailed = true;
					}
				);
			}
		}
	};
</script>
